var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDairyProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m198.589 450.984h-198.589v59.767h234.629c-17.435-15.626-30.229-36.33-36.04-59.767z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m263.038 88.718h-215.326l-47.36 70.479h229.201z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m221.044 320.123c.958-2.061 1.962-4.146 3.007-6.243v-124.758h-224.051v231.936h195.124c.321-28.192 10.418-67.6 25.92-100.935z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m59.409 0h221.286v58.792h-221.286z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m495.826 309.805c-21.57-19.419-58.541-13.054-93.491 2.507 1.333 2.627 2.599 5.237 3.796 7.81 15.755 33.881 25.935 74.042 25.935 102.316 0 35.692-15.844 67.75-40.862 89.504 1.043.036 2.086.057 3.129.057 24.709 0 49.225-10.141 66.709-29.589 16.041-17.844 33.295-51.006 42.935-82.519 12.985-42.445 10.166-73.597-8.151-90.086z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m262.748 159.197h64.347l-33.488-64.952z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m254.031 189.122v80.615c15.61-16.236 35.272-27.9 59.557-27.9 6.81 0 13.253.923 19.349 2.601v-55.316z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m403.086 422.439c0-24.001-9.336-60.202-23.23-90.081-18.716-40.247-41.631-61.52-66.269-61.52s-47.553 21.273-66.269 61.52c-13.894 29.879-23.23 66.08-23.23 90.081 0 49.384 40.149 89.561 89.499 89.561s89.499-40.177 89.499-89.561z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairyProducts);
export default __webpack_public_path__ + "static/media/dairy-products.e886dc4c14e02c01291f13fbddb770f3.svg";
export { ForwardRef as ReactComponent };